import { CSSObject } from '@emotion/react'
import { Typography, Spacing, Theme, Color, OppositeTheme } from '@opallabs/gem'
import { type WithRequiredTheme } from '../../gem'

export const listContainer = (searchable: boolean): CSSObject => ({
  display: 'flex',
  flexFlow: 'column wrap',
  margin: 0,
  marginTop: searchable ? Spacing.XS : 0,
  padding: 0,
})

export const listItem = (theme: Theme): CSSObject => ({
  alignItems: 'center',
  borderRadius: 2,
  columnGap: Spacing.S,
  display: 'flex',
  justifyContent: 'space-between',
  padding: `8px`,
  position: 'relative',

  '&:hover': {
    backgroundColor: Color[theme].Surface.A000,
  },
  '&.dragging:hover': {
    backgroundColor: Color[theme].Surface.N200,
  },
  '> .lapidary-toggle': {
    flexShrink: 0,
  },
})

export const label = (
  theme: Theme,
  isOriginalLocationWhileDragging: boolean
): CSSObject => ({
  ...Typography.T500,
  alignItems: 'center',
  display: 'flex',
  columnGap: Spacing.S,
  flexFlow: 'row nowrap',
  color: Color[theme].Text.Default,
  visibility: isOriginalLocationWhileDragging ? 'hidden' : 'visible',
})

export const lineClamp = (displayLabel: string): CSSObject => ({
  display: '-webkit-box',
  maxWidth: displayLabel ? 200 : undefined,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
})

export const tooltip: CSSObject = {
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 10,
  paddingBlock: 3,
}

export const displayLabel = (
  theme: Theme,
  isOriginalLocationWhileDragging: boolean
): CSSObject => ({
  display: 'flex',
  flex: 1,
  fontWeight: 400,
  justifyContent: 'flex-end',
  color: Color[theme].Text.Gray,
  visibility: isOriginalLocationWhileDragging ? 'hidden' : 'visible',
})

export const searchOverrides = (theme: Theme): CSSObject => ({
  svg: {
    color: Color[OppositeTheme[theme]].Surface.N000,
    fill: Color[OppositeTheme[theme]].Surface.N000,
  },
})

export const dragHandle = ({
  dragging,
  theme,
}: WithRequiredTheme & { dragging: boolean }): CSSObject => ({
  background: 'none',
  border: 0,
  color: dragging ? 'transparent' : Color[OppositeTheme[theme]].Surface.N000,
  cursor: dragging ? 'grabbing' : 'grab',
  fontSize: 20,
  lineHeight: 0.75,
  padding: 0,
  userSelect: 'none',
})
